import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {CustomMessageService, ResponseHttpError, ResponseHttpSuccess, UtilService} from "library";
import {HttpStatusCode} from "@angular/common/http";
import {SalesWorkflowSteps} from "projects/store/src/app/enums";
import {environment} from "projects/store/src/environments/environment";

enum InternalStepOptions { status, confirmation, confirmationClosed};

const PHONE = environment.global.country.customerServicePhone;
const CUSTOMER_SERVICE_CONTACT_MESSAGE = `De cualquier manera, te invitamos a que contactes a nuestro equipo de atención al cliente, al número <span class="font-bold">${PHONE}</span>, quienes gustosamente te ayudaran a continuar con el proceso.`;
const IMEI_ERROR_MESSAGE = `Puede que el IMEI no sea el correcto`;
@Component({
  selector: 'app-sales-phone-enrollment-manual-in-progress',
  templateUrl: './sales-phone-enrollment-manual-in-progress.component.html',
  styles: [
  ]
})

export class SalesPhoneEnrollmentManualInProgressComponent implements OnInit, OnDestroy{

  private backToProductsTimer: any;
  private enrollmentStatusTimer: any;
  private slideMessageTimer: any;
  showBackToProducts: boolean = false;

  messages: string[] = [
    'Este proceso normalmente tarda algunos minutos, por favor se paciente.',
    'Seguimos enrollando el teléfono. Pronto terminaremos...',
    'Falta poco, te pedimos un poco más de paciencia por favor...'
  ];
  messageCurrent: string = '';
  indexMessage: number = 0;
  requestId: string;
  flowCode: string;
  categoryId: string;
  internalStep: InternalStepOptions = InternalStepOptions.status ;
  request: any;

  @Output() step = new EventEmitter();
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter()
  @Output() onError = new EventEmitter();

  constructor( private route: ActivatedRoute, private requestService: RequestService,
               private utilService: UtilService, private customMessageService: CustomMessageService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.categoryId = this.requestService.categoryId;
    this.request = this.requestService.request;
  }

  ngOnInit() {
    this.showSlideMessage();
    this.onCheckEnrollmentStatus();
    this.backToProductsTimer = setTimeout(() => {
      this.showBackToProducts = true;
    }, 60000);
  }

  ngOnDestroy() {
    if (this.backToProductsTimer) {
      clearTimeout(this.backToProductsTimer);
    }
    if (this.enrollmentStatusTimer) {
      clearTimeout(this.enrollmentStatusTimer);
    }
    if (this.slideMessageTimer) {
      clearTimeout(this.slideMessageTimer);
    }
  }

  onCheckEnrollmentStatus() {
    this.requestService.getEnrollmentStatusTelephone(this.requestId).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.internalStep = InternalStepOptions.confirmation;
        } else if (resp.status === HttpStatusCode.PartialContent) {
          this.enrollmentStatusTimer = setTimeout(() => this.onCheckEnrollmentStatus(), 10000);
        } else {
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        switch (error.status) {
          case HttpStatusCode.NotAcceptable: // 406
            // TODO mejorar deberia ser una respuesta sin necesidad de ir a un error personalizado. Importante el manejo de los botones
            this.customMessageService.logErrorOnly(error);
            this.onRetryIMEI(error.error.message);
            break;

          case HttpStatusCode.Conflict: // 409
            // TODO mejorar deberia ser una respuesta sin necesidad de ir a un error personalizado
            this.customMessageService.logErrorOnly(error);
            this.onFailMessage();
            break;

          default:
            this.customMessageService.responseNoticeHandler(error);
            break;
        }
      }
    });
  }


  showSlideMessage() {
    this.messageCurrent = this.messages[this.indexMessage];
    this.indexMessage++;
    if (this.indexMessage < this.messages.length) {
      this.slideMessageTimer = setTimeout(() => {
        this.showSlideMessage();
      }, 15000);
    }
  }

  onNextStep() {
    this.internalStep = InternalStepOptions.confirmationClosed;
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  onRetryIMEI(message: string){
    this.onError.emit(message);
    this.step.emit('retry-message');
  }

  onFailMessage(){
    this.step.emit('fail-message');
  }

  onGotoStep(stepCode: string) {
    this.internalStep = InternalStepOptions.confirmationClosed;
    this.utilService.enablePageLoading();
    this.gotoStepEvent.emit({ flowCode: this.flowCode, stepCode, categoryId: this.categoryId });
  }

  onConfirmation() {
    return this.internalStep === InternalStepOptions.confirmation
  }

  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;
  protected readonly InternalStepOptions = InternalStepOptions
}
